// frontend/src/components/layouts/DashboardLayout.js
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './DashboardLayout.css';

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Call backend logout
      await axios.post('https://api.carrenahealth.com/api/auth/logout', {}, {
        withCredentials: true
      });
  
      // Clear all cookies
      document.cookie.split(";").forEach(c => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
  
      // Clear storages
      localStorage.clear();
      sessionStorage.clear();
  
      // Force reload to clear any in-memory state
      window.location.href = '/';
    } catch (err) {
      console.error('Logout error:', err);
      // Force reload even if logout fails
      window.location.href = '/';
    }
  };

  return (
    <div className="dashboard-layout">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>Carrena Health</h1>
          <button 
            onClick={handleLogout}
            className="logout-button"
          >
            Logout
          </button>
        </div>
      </header>
      <main className="dashboard-content">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
